import { API } from "../api";
import axios from "axios";

const jsonHeaders = { "Content-Type": "application/json" };

export const findDuplicates = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/admin/duplicates`);
    return data;
  } catch (err) {
    console.error("Error finding duplicates:", err);
    return { success: false, count: 0, data: [] };
  }
};

export const deleteDuplicateCar = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/delete/${id}`);
    return data;
  } catch (err) {
    console.error("Error deleting car:", err);
    throw new Error(err);
  }
};

export const bulkDeleteCars = async (ids) => {
  try {
    const deletePromises = ids.map(id => 
      axios.get(`${API.DEV}/car/delete/${id}`)
    );
    const results = await Promise.all(deletePromises);
    return results;
  } catch (err) {
    console.error("Error bulk deleting cars:", err);
    throw new Error(err);
  }
};
